// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon('eva:pie-chart-outline'),
  },
  {
    title: 'atlasing',
    path: '/dashboard/atlasing',
    icon: getIcon('eva:bar-chart-outline'),
  },
  {
    title: 'checklists',
    path: '/dashboard/checklists',
    icon: getIcon('eva:checkmark-outline'),
  },
  {
    title: 'formslists',
    path: '/dashboard/forms',
    icon: getIcon('eva:copy-outline'),
  },
  // {
  //   title: 'Import Data',
  //   path: '/dashboard/importer',
  //   icon: getIcon('eva:plus-circle-outline'),
  // },
  // {
  //   title: 'observers',
  //   path: '/dashboard/observers',
  //   icon: getIcon('eva:people-fill'),
  // },
  // {
  //   title: 'product',
  //   path: '/dashboard/products',
  //   icon: getIcon('eva:shopping-bag-fill'),
  // },
  {
    title: 'Updates',
    path: '/news',
    icon: getIcon('eva:file-text-outline'),
  },
  // {
  //   title: 'Your Posts',
  //   path: '/dashboard/posts',
  //   icon: getIcon('eva:bookmark-outline'),
  // },
  // {
  //   title: 'Write',
  //   path: '/dashboard/write',
  //   icon: getIcon('eva:edit-2-outline'),
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: getIcon('eva:lock-fill'),
  // },
  // {
  //   title: 'register',
  //   path: '/register',
  //   icon: getIcon('eva:person-add-fill'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: getIcon('eva:alert-triangle-fill'),
  // },
];

export default navConfig;
